import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, isRef as _isRef, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ca4674c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("新增用户")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("导出花名册")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("待完善")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("查看重复员工")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("未维护离职员工")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("变更记录")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 维护 ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("重新入职")
const _hoisted_12 = { class: "dialog-footer" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "checkboxW" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("导出")
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("处理")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("确定")

import { onActivated, ref, Ref, reactive, onBeforeMount } from 'vue'
import tbMix from '@/global_mixin/tableMixin'
import { ElMessage, ElMessageBox } from 'element-plus'
import { checkCardId } from '@/utils/validate'
import { formatTime } from '@/utils/index'
import type { ElForm } from 'element-plus'
import { useRoute } from 'vue-router'
import ExceptionList from '@/views/ViewsComponents/humanMaintain/ExceptionList.vue'
import store from '@/store/index'
import dayjs from "dayjs"
import Api from '@/http/modules/index'
type FormInstance = InstanceType<typeof ElForm>

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const {
    'POST/users/profile/list': fetchList,
    // 公司列表
    'GET/company': companyListApi,
    // 部门（树）
    'GET/departments/tree': departmentsTreeApi ,
    // 岗位列表
    'GET/jobs': jobsListApi,
    // 获取所有团队
    'GET/organizations': organizationsListApi,
    // 新增员工
    'POST/users': addUserApi,
    // 批量上传新员工
    'POST/users/upload': uploadUsersApi,
    // 判断用户名是否存在
    'GET/users/check_name': existUserNameApi,
    // 导出所有员工
    'POST/users/export': userExportApi,
    // 未完善员工
    'GET/users/profile': perfectTipApi,
    // 校验身份证号码是否已存在系统
    'GET/users/check_card': checkCardApi,
    // 校验邮箱是否重复
    'GET/users/check_email': checkEmailApi,
    // 获取劳动合同快到期员工
    'GET/users/contracts/expired': contractsExpiredApi,
    // 根据姓名或者身份证查重
    'GET/users/repeat': repeatListApi,
    // 未维护离职员工
    'GET/users/profile/quit': quitApi,
    // 打卡规则list
    'GET/checkin_punch_rules': ruleListApi,
    // 批量修改员工信息
    'PATCH/users/batch_update': batch_updateApi,
    // 下载批量修改员工信息模板
    'GET/users/info_template': info_templateApi,
    // 获取财务岗位下拉
    'GET/user_finances': financialJobListApi,
    // 获取员工变更记录
    'POST/user_change_records': user_change_recordsApi,
    // 处理变动记录
    'PATCH/user_change_records/handle': handleApi,
    // 离职转入职
    'POST/users/resign_employee':resignEmployeeApi,
    // 所有办公所在地
  'GET/house_leases': fullOfficeApi,
} = Api

const route = useRoute()
let { 
    MI_height, MI_tableData, fetchData, page, size, MI_total, 
    MI_params, MI_pageChange, MI_identify, MI_sizeChange 
} = new tbMix(fetchList)
let departmentsList = ref<any[]>([])
let jobsList = ref<any[]>([])
let organization = ref<any[]>([])
let perfectTipList = ref<any[]>([])
let contractTipList = ref<any[]>([])
const tipLength = ref<number>(0)
// const contractsTips = ref<number>(0)
let ruleList = ref<any[]>([])
let financialJobList: any = ref([])
let officeList:any=ref([])
onBeforeMount(() => {
    fetchData()

    // 部门
    departmentsTreeApi().then((rep: any) => {
        departmentsList.value = rep
    })
    // 岗位
    jobsListApi({types: 'ALL'}).then((rep: any) => {
        jobsList.value = rep
    })
    // 团队
    organizationsListApi().then((rep: any) => {
        organization.value = rep
    })
    // 获取未完善员工信息
    perfectTipApi().then((rep: any) => {
        perfectTipList.value = rep
        tipLength.value = rep.length
    })
    // 获取合同到期员工信息
    /* contractsExpiredApi().then((rep: any) => {
        contractTipList.value = rep
        contractsTips.value = rep.length
    }) */
    // 离职未维护员工
    quitApi().then((rep: any) => {
        quitLength.value = rep.length
    })
    ruleListApi().then((rep: any) => {
        ruleList.value = rep
    })
    financialJobListApi().then((rep: any) => {
        financialJobList.value = rep.concat([{name: 'null', id: 'null'}])
    })
    fullOfficeApi().then((res:any)=>{
        officeList.value=res
    })
})
onActivated(() => {
    if(route.query.refresh === 'true'){
        fetchData(MI_params);
        perfectTipApi().then((rep: any) => {
            perfectTipList.value = rep
            tipLength.value = rep.length
        })
        /* contractsExpiredApi().then((rep: any) => {
            contractTipList.value = rep
            contractsTips.value = rep.length
        }) */
    }
})

// search module
const searchEle = ref()
const searchObj = reactive({
  key: '', cardId: '', companyIds: '', orgIds: '', 
  staffType: '', jobId: '', financeStationId: '',
  timeRange: [], departureRange: [],  hiredTime: '',
})
const searchHandle = () => {
  fetchData({
    ...searchObj,
    hiredStartTime: searchObj.timeRange?.[0],
    hiredEndTime: searchObj.timeRange?.[1],
    departureStartTime: searchObj.departureRange?.[0],
    departureEndTime: searchObj.departureRange?.[1],
  })
}
// 新增公司成员
let additionUserFg: Ref<boolean> = ref(false)
let addBtnFg: Ref<boolean> = ref(false)
const additionInfo: any = reactive({
    // 英文名
    alias: '',
    username: '',
    email: '',
    phoneNumber: '',
    // 证件类型
    cardType: '',
    // 证件姓名
    realName: '',
    // 证件号码
    cardId: '',
    orgId: [],
    // 公司id
    companyId: '',
    // 部门id
    departmentPath: '',
    // 岗位id
    jobId: '',
    // 打卡规则id
    ruleId: '',
})
const additionInfoRules = {
    username: [ 
        { required: true,message: '请输入登录名', trigger: 'change' },
        {
            validator: async (rule: any, value: any, callback: any) => {
                if((await existUserNameApi({username: value})).exists === true){
                    // 登录名已存在
                    callback(new Error('登录名已存在'))
                    return
                }
                callback()
            },
            trigger: 'change' 
        },
    ],
    alias: [ 
        { required: true, message: '请输入英文名', trigger: 'change' },
        {
            validator: async (rule: any, value: any, callback: any) => {
                if(!/^[a-zA-Z\s]{4,50}$/.test(value)){
                    callback(new Error('请输入正确英文名'))
                    return
                }
                callback()
            },
            trigger: 'change' 
        }
    ],
    phoneNumber: [
        { required: true, message: '请输入手机号码', trigger: 'change', },
        { type: 'number', message: '请输入数字' },
    ],
    realName: [
        { required: true, message: '请输入证件姓名', trigger: 'change', },
    ],
    leaseId: [
        { required: true, message: '请选择办公所在地', trigger: 'change', },
    ],
    cardId: [
        { required: true, message: '请输入证件号码', trigger: 'change', },
        {
        validator: (rule: any, value: any, callback: any) => {
            if(additionInfo.cardType !== '居民身份证') {
                callback()
            } else if (!checkCardId(value.trim())) {
                callback(new Error('校验错误'))
            } else {
                callback()
            }
        },
        trigger: 'change'
      }
    ],
    cardType: [ {required: true,message: '请选择证件类型',trigger: 'change'} ],
    companyId: [ {required: true,message: '请选择公司',trigger: 'change'} ],
    orgId: [ {required: true,message: '请选择团队',trigger: 'change'} ],
    departmentPath: [ {required: true,message: '请选择部门',trigger: 'change'} ],
    jobId: [ {required: true,message: '请选择岗位',trigger: 'change'} ],
    email: [
        {required: true,message: '请输入邮箱',trigger: 'change' },
        {
            validator: async (rule: any, value: any, callback: any) => {
                if( !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(value)){
                    callback(new Error('请输入正确邮箱'))
                    return
                }
                if((await checkEmailApi({email: value})).exists === true){
                    // 登录名已存在
                    callback(new Error('邮箱已存在'))
                    return
                }
                callback()
            },
            trigger: 'change' 
        }
    ],
    ruleId: [ {required: true,message: '请选择打卡规则',trigger: 'change'} ],
}

const formRef: any = ref<FormInstance>()
const additionUserFn = (formEl: any) => {
    addBtnFg.value = true
    if (!formEl) {
        addBtnFg.value = false
        return
    }
    formEl.validate(async (valid: any) => {
        if (valid) {
            let cardInfos = await checkCardApi({cardId: additionInfo.cardId})
            // 如果有身份证号相同用户，提示用户姓名
            if(cardInfos.length > 0){
                let tips = cardInfos.reduce((str: string, item: any) => {
                    str += `${item.realName}(${item.alias})<br/>`
                    return str
                }, '')
                addBtnFg.value = false
                await ElMessageBox.confirm(
                    tips,
                    '已经有重复证件号码，是否继续？',
                    {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        dangerouslyUseHTMLString: true,
                        type: 'warning',
                    }
                )
            }
            try {
                addBtnFg.value = true
                await addUserApi(additionInfo)
                addBtnFg.value = false
                additionUserFg.value = false
                ElMessage.success('新增成功')
                fetchData(MI_params)
            } catch (error) {
                // additionUserFg.value = false
                addBtnFg.value = false
            }
            
        } else {
            addBtnFg.value = false
        }
    })

}
const selectChangeHandle = (configItem: any) => {
    // 下拉框change事件后，手动调用表单验证
    let {value, upKey} = configItem
    additionInfo[upKey] = value
    
    
}
// 部门选择回掉
const departmentsHandle = (value: any) => {
    additionInfo.jobId = ''
    jobsListApi({ departmentId: value[value.length - 1] }).then((rep: any) => {
        jobsList.value = rep
    })
}

const addCloseHandle = () => {
    Object.keys(additionInfo).forEach(_key =>{
        additionInfo[_key] = ''
    })
    formRef.value.resetFields()
}

// 未完善员工
const tipFg = ref<boolean>(false)
const userTipHandle = () => {
    MI_identify.value = true
    perfectTipApi().then((rep: any) => {
        perfectTipList.value = rep
        tipLength.value = rep.length
        MI_identify.value = false
        tipFg.value = true
    }).catch(() => {
        MI_identify.value = false
    })
}

// 合同到期提醒
/* const contractTipsFg = ref<boolean>(false)
const showContract = () => {
    MI_identify.value = true
    contractsExpiredApi().then((rep: any) => {
        contractTipList.value = rep
        tipLength.value = rep.length
        MI_identify.value = false
        contractTipsFg.value = true
    }).catch(() => {
        MI_identify.value = false
    })
} */
// 离职员工提示
let quitTableDate = ref([])
let quitLength = ref<number>(0)
const quitTipsFg = ref<boolean>(false)
const showResign = () => {
    MI_identify.value = true
    quitApi().then((rep: any) => {
        quitTableDate.value = rep
        quitLength.value = rep.length
        MI_identify.value = false
        quitTipsFg.value = true
    }).catch(() => {
        MI_identify.value = false
    })
}
// 导出花名册列选择
const exportHeadList = [
    "团队", "员工所在办公地区", "公司", "部门", "岗位", "职级", "在职状态", "姓名", "英文名",
    "证件类型", "证件号码", "性别", "出生年月", "籍贯", "现居住地", "婚姻状态", "手机号",
    "邮箱", "学历", "毕业学校", "专业", "入职日期", "工龄", "转正日期", "离职日期", 
    "离职原因", "劳动合同起", "劳动合同止", "劳动合同到期提醒", "招聘人事",
    "紧急联系人", "紧急联系人电话", "紧急联系人关系", "财务岗位", "直属上级", "火星ID"
]
const exportParams: any = reactive({
    keys: [],

})
const downUserBtnFg = ref<boolean>(false)
const exportFg = ref<boolean>(false)
const showExportUser = () => {
    exportFg.value = true
}
const exportHandle = async () => {
  ElMessage('开始下载')
  try {
    downUserBtnFg.value = true
    let stream: any = await userExportApi({...exportParams, ...MI_params}, {timeout: 5 * 60000, responseType: 'blob'})
    let fileName = decodeURI(stream.headers['content-disposition'].split(';')[1].split('filename=')[1])
    let url = window.URL.createObjectURL(
      new Blob([stream.data], { type: 'application/vnd.ms-excel;charset=utf-8' })
    )

    let link = document.createElement("a")
    link.style.display = "none"
    link.href = url
    link.setAttribute(
      "download",
      decodeURI(fileName)
    )
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    ElMessage.success('下载成功')
    downUserBtnFg.value = false
    exportFg.value = false
  } catch (error: any) {
    downUserBtnFg.value = false
    let reader = new FileReader();
    reader.onload = (e: any) => {
      ElMessage.error(JSON.parse(e.target.result).message)
    }
    reader.readAsText(error.response.data)
    ElMessage.error('下载失败')
  }
}

// 根据姓名或者身份证查重
const repeatMemberFg: any = ref<boolean>(false)
let repeatMemberList: any = ref([])
const showRepeatMember = async () => {
    if(!MI_params.key && !MI_params.cardId){
        ElMessage.warning('请先搜索员工姓名，或者证件号码')
        return
    }
    repeatMemberList.value = await repeatListApi({key: MI_params.key, cardId: MI_params.cardId})
    repeatMemberFg.value = true
}

// 变更记录
let changeData = ref([])
const isShowChange = ref<boolean>(false)
const isChangeLoad = ref<boolean>(false)
const changeId = ref()
const changeRange = ref([])

const showChange = () => {
    isShowChange.value = true
    isChangeLoad.value = true
    user_change_recordsApi({
      userId: changeId.value,
      createFrom: changeRange.value?.[0],
      createTo: changeRange.value?.[1],
    }).then((rep: any) => {
      changeData.value = rep
    }).finally(() => {
      isChangeLoad.value = false
    })
}
const changeHandle = (row: {id: number}) => {
    handleApi({id: row.id}).then(() => {
        showChange()
        ElMessage.success('处理成功')
    })
}
const resignEmployeeVisiable=ref(false)
const resignLoading=ref(false)
const resignInfo=ref<any>({
    date:'',
})
const humanType= [
    { label: '转正', value: '转正', },
    { label: '试用期', value: '试用期', },
    { label: '兼职', value: '兼职', },
    // { label: '离职', value: '离职', },
    { label: '实习生', value: '实习生', },
]
const resignEmployeeInfo=ref<any>({})
const beforeResignHandle=(row:any)=>{
    resignEmployeeInfo.value=row
    resignEmployeeVisiable.value=true
}
const closeResign=()=>{
    resignInfo.value={date:''}
    resignEmployeeInfo.value={}
}
const resignHandle=()=>{
    let {date,type}=resignInfo.value
    if(!date){
        ElMessage.warning("请选择入职时间")
        return
    }
    if(!type){
        ElMessage.warning("请选择人员状态")
        return
    }
    let daysDiff = dayjs(date).diff(dayjs(resignEmployeeInfo.value.departureDate), 'days');
    if(daysDiff<30){
        ElMessage.warning("距离上次离职时间不足30天，不让重新入职")
        return
    }
    let params={
        "userId":resignEmployeeInfo.value.userId,//用户id
        "type":type,//人员状态
        "hiredTime":dayjs(date).format('YYYY-MM-DD') //入职日期
    }
    resignLoading.value=true
    resignEmployeeApi(params).then((res:any)=>{
        ElMessage.success("操作成功")
        fetchData()
        resignEmployeeVisiable.value=false
    }).finally(()=>{
        resignLoading.value=false
    })
}


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_option_group = _resolveComponent("el-option-group")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_TheUpBtn = _resolveComponent("TheUpBtn")!
  const _component_eptBtn = _resolveComponent("eptBtn")!
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _directive_permission = _resolveDirective("permission")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_collapse, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "人资" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              ref_key: "searchEle",
              ref: searchEle,
              model: _unref(searchObj),
              inline: "",
              class: "searchBg",
              disabled: _unref(MI_identify)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "姓名:",
                  prop: "key"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(searchObj).key,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(searchObj).key) = $event)),
                      class: "form-input",
                      placeholder: "请输入姓名",
                      clearable: "",
                      maxlength: "100",
                      onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (searchHandle()), ["enter"]))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "证件号码:",
                  prop: "cardId"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(searchObj).cardId,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(searchObj).cardId) = $event)),
                      class: "form-input",
                      placeholder: "请输入证件号码",
                      clearable: "",
                      maxlength: "100",
                      onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (searchHandle()), ["enter"]))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "公司:",
                  prop: "companyIds"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(searchObj).companyIds,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(searchObj).companyIds) = $event)),
                      style: {"width":"380px"},
                      filterable: "",
                      multiple: "",
                      "collapse-tags": "",
                      placeholder: "请选择公司"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).getters.sysCompany, (group) => {
                          return (_openBlock(), _createBlock(_component_el_option_group, {
                            label: group.label,
                            key: group.label
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.options, (comp) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  label: comp.name,
                                  value: comp.id,
                                  key: comp.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["label"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "团队:",
                  prop: "orgIds"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      placeholder: "请选择团队",
                      modelValue: _unref(searchObj).orgIds,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(searchObj).orgIds) = $event)),
                      filterable: "",
                      clearable: "",
                      multiple: "",
                      "collapse-tags": ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).getters.sysOrganizations, (org) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            label: org.name,
                            value: org.id,
                            key: org.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "人员状态:",
                  prop: "staffType"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      placeholder: "请选择人员状态",
                      modelValue: _unref(searchObj).staffType,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(searchObj).staffType) = $event)),
                      filterable: "",
                      clearable: "",
                      multiple: "",
                      "collapse-tags": ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "转正",
                          value: "转正"
                        }),
                        _createVNode(_component_el_option, {
                          label: "试用期",
                          value: "试用期"
                        }),
                        _createVNode(_component_el_option, {
                          label: "兼职",
                          value: "兼职"
                        }),
                        _createVNode(_component_el_option, {
                          label: "离职",
                          value: "离职"
                        }),
                        _createVNode(_component_el_option, {
                          label: "实习生",
                          value: "实习生"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "岗位名称:",
                  prop: "jobId"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      placeholder: "请选择岗位名称",
                      modelValue: _unref(searchObj).jobId,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(searchObj).jobId) = $event)),
                      filterable: "",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(jobsList), (job) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            label: job.name,
                            value: job.id,
                            key: job.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "财务岗位:",
                  prop: "financeStationId"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      placeholder: "请选择财务岗位",
                      modelValue: _unref(searchObj).financeStationId,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(searchObj).financeStationId) = $event)),
                      filterable: "",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(financialJobList), (job) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            label: job.name,
                            value: job.id,
                            key: job.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "入职时间:",
                  prop: "timeRange"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _unref(searchObj).timeRange,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(searchObj).timeRange) = $event)),
                      "value-format": "YYYY-MM-DD",
                      type: "daterange",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                      "disabled-date": (time) => time.getTime() > Date.now()
                    }, null, 8, ["modelValue", "disabled-date"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "离职时间:",
                  prop: "departuretimeRange"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _unref(searchObj).departureRange,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(searchObj).departureRange) = $event)),
                      "value-format": "YYYY-MM-DD",
                      type: "daterange",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                      "disabled-date": (time) => time.getTime() > Date.now()
                    }, null, 8, ["modelValue", "disabled-date"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "截止时间:",
                  prop: "hiredTime"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _unref(searchObj).hiredTime,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(searchObj).hiredTime) = $event)),
                      "value-format": "YYYY-MM-DD",
                      placeholder: "请选择截止时间"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _hoisted_1,
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (searchHandle())),
                      type: "primary"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (searchEle.value.resetFields()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "disabled"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_button, {
      type: "primary",
      class: "mb-5 mt-5",
      onClick: _cache[14] || (_cache[14] = ($event: any) => (_isRef(additionUserFg) //@ts-ignore
 ? additionUserFg.value = true : additionUserFg = true)),
      disabled: _unref(MI_identify)
    }, {
      default: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    }, 8, ["disabled"])), [
      [_directive_permission, 'Create']
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_button, {
      onClick: showExportUser,
      disabled: _unref(MI_identify)
    }, {
      default: _withCtx(() => [
        _hoisted_5
      ]),
      _: 1
    }, 8, ["disabled"])), [
      [_directive_permission, 'Export']
    ]),
    _withDirectives(_createVNode(_component_TheUpBtn, {
      class: "ml-10",
      showBtn: true,
      upText: '批量上传',
      upFetch: _unref(uploadUsersApi),
      upParams: {},
      onUpSuccess: _cache[15] || (_cache[15] = ($event: any) => (_unref(fetchData)(_unref(MI_params))))
    }, null, 8, ["upFetch"]), [
      [_directive_permission, 'Create']
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_TheUpBtn, {
      class: "ml-10",
      showBtn: true,
      upText: '批量修改',
      upFetch: _unref(batch_updateApi),
      upParams: {},
      onUpSuccess: _cache[16] || (_cache[16] = ($event: any) => (_unref(fetchData)(_unref(MI_params))))
    }, {
      default: _withCtx(() => [
        _withDirectives(_createVNode(_component_eptBtn, {
          exportFn: _unref(info_templateApi),
          exportText: '下载批量修改员工信息模板',
          exportParam: {},
          isDirect: true
        }, null, 8, ["exportFn"]), [
          [_directive_permission, 'Export']
        ])
      ]),
      _: 1
    }, 8, ["upFetch"])), [
      [_directive_permission, 'Write']
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_badge, {
      value: tipLength.value,
      type: "warning"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_button, {
          class: "ml-10",
          onClick: _cache[17] || (_cache[17] = ($event: any) => (userTipHandle())),
          disabled: _unref(MI_identify)
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _: 1
    }, 8, ["value"])), [
      [_directive_permission, 'Write']
    ]),
    _createVNode(ExceptionList, { class: "ml-20" }),
    _withDirectives((_openBlock(), _createBlock(_component_el_button, {
      class: "ml-20",
      onClick: _cache[18] || (_cache[18] = ($event: any) => (showRepeatMember())),
      disabled: _unref(MI_identify)
    }, {
      default: _withCtx(() => [
        _hoisted_7
      ]),
      _: 1
    }, 8, ["disabled"])), [
      [_directive_permission, 'Write']
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_badge, {
      value: _unref(quitLength),
      type: "warning"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_button, {
          class: "ml-10",
          onClick: _cache[19] || (_cache[19] = ($event: any) => (showResign())),
          disabled: _unref(MI_identify)
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _: 1
    }, 8, ["value"])), [
      [_directive_permission, 'Write']
    ]),
    _createVNode(_component_el_button, {
      class: "ml-10",
      onClick: _cache[20] || (_cache[20] = ($event: any) => (showChange())),
      disabled: _unref(MI_identify)
    }, {
      default: _withCtx(() => [
        _hoisted_9
      ]),
      _: 1
    }, 8, ["disabled"]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      data: _unref(MI_tableData),
      border: "",
      "max-height": _unref(MI_height) + 'px'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "realName",
          label: "姓名",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          prop: "alias",
          label: "英文名",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          prop: "comName",
          label: "劳动关系归属公司",
          width: "250",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          prop: "orgName",
          label: "团队"
        }),
        _createVNode(_component_el_table_column, {
          prop: "position",
          label: "岗位名称"
        }),
        _createVNode(_component_el_table_column, {
          prop: "hiredTime",
          label: "入职日期"
        }),
        _createVNode(_component_el_table_column, {
          prop: "staffType",
          label: "人员状态"
        }),
        _createVNode(_component_el_table_column, {
          prop: "positiveDate",
          label: "转正日期"
        }),
        _createVNode(_component_el_table_column, {
          prop: "departureDate",
          label: "离职日期"
        }),
        _createVNode(_component_el_table_column, { label: "操作" }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_space, null, {
              default: _withCtx(() => [
                _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                  type: "primary",
                  onClick: ($event: any) => (_ctx.$router.push({ name: 'userMaintain', params: scope.row }))
                }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 2
                }, 1032, ["onClick"])), [
                  [_directive_permission, 'Write']
                ]),
                (scope.row.staffType=='离职')
                  ? (_openBlock(), _createBlock(_component_el_link, {
                      key: 0,
                      onClick: ($event: any) => (beforeResignHandle(scope.row))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_11
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_pagination, {
      background: "",
      small: "",
      total: _unref(MI_total),
      currentPage: _unref(page),
      "onUpdate:currentPage": _cache[21] || (_cache[21] = ($event: any) => (_isRef(page) ? (page).value = $event : page = $event)),
      "page-size": _unref(size),
      "onUpdate:page-size": _cache[22] || (_cache[22] = ($event: any) => (_isRef(size) ? (size).value = $event : size = $event)),
      class: "mt-10",
      disabled: _unref(MI_identify),
      "page-sizes": [30, 50, 100, 200],
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: _unref(MI_pageChange),
      onSizeChange: _unref(MI_sizeChange)
    }, null, 8, ["total", "currentPage", "page-size", "disabled", "onCurrentChange", "onSizeChange"]),
    _createVNode(_component_el_dialog, {
      modelValue: _unref(additionUserFg),
      "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => (_isRef(additionUserFg) ? (additionUserFg).value = $event : additionUserFg = $event)),
      title: "新增用户",
      onClose: addCloseHandle
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_12, [
          _createVNode(_component_el_button, {
            onClick: _cache[36] || (_cache[36] = ($event: any) => (_isRef(additionUserFg) //@ts-ignore
 ? additionUserFg.value = false : additionUserFg = false))
          }, {
            default: _withCtx(() => [
              _hoisted_13
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[37] || (_cache[37] = ($event: any) => (additionUserFn(formRef.value))),
            loading: _unref(addBtnFg)
          }, {
            default: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          inline: true,
          rules: additionInfoRules,
          ref_key: "formRef",
          ref: formRef,
          model: _unref(additionInfo),
          "label-width": "120px",
          "label-position": "top"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "英文名:",
              prop: "alias"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  class: "form-input",
                  modelValue: _unref(additionInfo).alias,
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_unref(additionInfo).alias) = $event)),
                  placeholder: "请输入英文名",
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "登录名:",
              prop: "username"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  class: "form-input",
                  modelValue: _unref(additionInfo).username,
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_unref(additionInfo).username) = $event)),
                  placeholder: "请输入登录名",
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "手机号码:",
              prop: "phoneNumber"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  class: "form-input",
                  modelValue: _unref(additionInfo).phoneNumber,
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_unref(additionInfo).phoneNumber) = $event)),
                  modelModifiers: { number: true },
                  placeholder: "请输入手机号码",
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "证件类型:",
              prop: "cardType"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(additionInfo).cardType,
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_unref(additionInfo).cardType) = $event)),
                  placeholder: "请选择证件类型"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "居民身份证",
                      value: "居民身份证"
                    }),
                    _createVNode(_component_el_option, {
                      label: "护照",
                      value: "护照"
                    }),
                    _createVNode(_component_el_option, {
                      label: "港澳台通行证及其他",
                      value: "港澳台通行证及其他"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "证件姓名:",
              prop: "realName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  class: "form-input",
                  modelValue: _unref(additionInfo).realName,
                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_unref(additionInfo).realName) = $event)),
                  placeholder: "请输入证件姓名",
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "证件号码:",
              prop: "cardId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  class: "form-input",
                  modelValue: _unref(additionInfo).cardId,
                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_unref(additionInfo).cardId) = $event)),
                  placeholder: "请输入证件号码",
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "邮箱:",
              prop: "email"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  class: "form-input",
                  modelValue: _unref(additionInfo).email,
                  "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_unref(additionInfo).email) = $event)),
                  placeholder: "请输入邮箱",
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "公司:",
              prop: "companyId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(additionInfo).companyId,
                  "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_unref(additionInfo).companyId) = $event)),
                  placeholder: "请选择公司",
                  clearable: "",
                  filterable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).getters.sysCompany, (group) => {
                      return (_openBlock(), _createBlock(_component_el_option_group, {
                        label: group.label,
                        key: group.label
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.options, (comp) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: comp.name,
                              value: comp.id,
                              key: comp.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "部门:",
              prop: "departmentPath"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_cascader, {
                  modelValue: _unref(additionInfo).departmentPath,
                  "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_unref(additionInfo).departmentPath) = $event)),
                  props: {
                        label: 'name',
                        value: 'departmentId'
                    },
                  options: _unref(departmentsList),
                  onChange: departmentsHandle
                }, null, 8, ["modelValue", "options"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "岗位:",
              prop: "jobId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(additionInfo).jobId,
                  "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_unref(additionInfo).jobId) = $event)),
                  placeholder: "请选择岗位",
                  filterable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(jobsList), (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.name,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "团队:",
              prop: "orgId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(additionInfo).orgId,
                  "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_unref(additionInfo).orgId) = $event)),
                  placeholder: "请选择团队",
                  filterable: "",
                  multiple: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(organization), (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.name,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "打卡规则:",
              prop: "ruleId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(additionInfo).ruleId,
                  "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_unref(additionInfo).ruleId) = $event)),
                  placeholder: "请选择打卡规则",
                  filterable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ruleList), (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.name,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "办公所在地:",
              prop: "leaseId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  filterable: "",
                  class: "form-input",
                  modelValue: _unref(additionInfo).leaseId,
                  "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_unref(additionInfo).leaseId) = $event)),
                  placeholder: "请选择办公所在地",
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(officeList), (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: item.alias,
                        key: item.id,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: tipFg.value,
      "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((tipFg).value = $event)),
      top: "50px",
      title: "待完善员工信息"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          border: "",
          data: _unref(perfectTipList),
          "max-height": "680"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "name",
              label: "姓名"
            }, {
              default: _withCtx(({row}) => [
                _createElementVNode("div", {
                  class: "pointer",
                  onClick: ($event: any) => {tipFg.value = false ;_ctx.$router.push({ name: 'userMaintain', params: row })}
                }, _toDisplayString(row.name), 9, _hoisted_15)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "fields",
              label: "字段"
            }),
            _createVNode(_component_el_table_column, {
              prop: "day",
              label: "提醒天数",
              align: "right",
              width: "90"
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "请选择花名册导出表头",
      modelValue: exportFg.value,
      "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((exportFg).value = $event))
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[41] || (_cache[41] = ($event: any) => (exportHandle())),
          loading: downUserBtnFg.value
        }, {
          default: _withCtx(() => [
            _hoisted_17
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_alert, {
          class: "mb-20",
          closable: false,
          title: "都不选，默认导出以上全部表头",
          type: "info",
          effect: "dark"
        }),
        _createVNode(_component_el_checkbox_group, {
          modelValue: _unref(exportParams).keys,
          "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_unref(exportParams).keys) = $event))
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(exportHeadList, (_head) => {
              return _createVNode(_component_el_checkbox, {
                label: _head,
                key: _head
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_16, _toDisplayString(_head), 1)
                ]),
                _: 2
              }, 1032, ["label"])
            }), 64))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: repeatMemberFg.value,
      "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((repeatMemberFg).value = $event)),
      title: "重复员工列表",
      width: "70%"
    }, {
      default: _withCtx(() => [
        (_unref(repeatMemberList).length === 0)
          ? (_openBlock(), _createBlock(_component_el_alert, {
              key: 0,
              title: "暂无重复员工，建议搜索完整姓名或者完整证件号码后重试",
              type: "info",
              effect: "dark",
              description: `姓名：  ${_unref(MI_params).key || ''} ,证件号码： ${_unref(MI_params).cardId || ''}`
            }, null, 8, ["description"]))
          : _createCommentVNode("", true),
        (_unref(repeatMemberList).length !== 0)
          ? (_openBlock(), _createBlock(_component_el_alert, {
              key: 1,
              title: "搜索参数：",
              closable: false,
              type: "warning",
              effect: "dark",
              description: `姓名：  ${_unref(MI_params).key || ''} ,证件号码： ${_unref(MI_params).cardId || ''}`
            }, null, 8, ["description"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table, {
          border: "",
          data: _unref(repeatMemberList),
          class: "mt-10",
          "max-height": "380"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "realName",
              label: "姓名",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              prop: "alias",
              label: "英文名",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              prop: "comName",
              label: "劳动关系归属公司",
              width: "250",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              prop: "orgName",
              label: "团队"
            }),
            _createVNode(_component_el_table_column, {
              prop: "position",
              label: "岗位名称"
            }),
            _createVNode(_component_el_table_column, {
              prop: "hiredTime",
              label: "入职日期"
            }),
            _createVNode(_component_el_table_column, {
              prop: "staffType",
              label: "人员状态"
            }),
            _createVNode(_component_el_table_column, {
              prop: "positiveDate",
              label: "转正日期"
            }),
            _createVNode(_component_el_table_column, {
              prop: "departureDate",
              label: "离职日期"
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: quitTipsFg.value,
      "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((quitTipsFg).value = $event)),
      top: "50px",
      title: "离职未维护员工信息"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          border: "",
          data: _unref(quitTableDate),
          "max-height": "680px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "realName",
              label: "姓名"
            }, {
              default: _withCtx(({row}) => [
                _createElementVNode("div", {
                  class: "pointer",
                  onClick: ($event: any) => {_isRef(perfectTipList) //@ts-ignore
 ? perfectTipList.value = false : perfectTipList = false ;_ctx.$router.push({ name: 'userMaintain', params: row })}
                }, _toDisplayString(row.realName + "("+ row.alias + ")"), 9, _hoisted_18)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "变更记录",
      modelValue: isShowChange.value,
      "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((isShowChange).value = $event)),
      onClose: _cache[48] || (_cache[48] = ($event: any) => (changeId.value = '', changeRange.value = []))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          inline: "",
          class: "searchBg",
          disabled: isChangeLoad.value
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "姓名:",
              prop: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  clearable: "",
                  modelValue: changeId.value,
                  "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((changeId).value = $event)),
                  filterable: "",
                  placeholder: "请选择员工",
                  class: "form-input"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).getters.sysUsers, (user) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: `${user.alias} (${user.realName})`,
                        value: user.userId,
                        key: user.userId
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "变更日期:",
              prop: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: changeRange.value,
                  "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((changeRange).value = $event)),
                  "value-format": "YYYY-MM-DD",
                  clearable: "",
                  "end-placeholder": "结束日期",
                  type: "daterange",
                  "start-placeholder": "开始日期"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: showChange
                }, {
                  default: _withCtx(() => [
                    _hoisted_19
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["disabled"]),
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          border: "",
          data: _unref(changeData),
          "max-height": "700px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "姓名",
              prop: "alias"
            }),
            _createVNode(_component_el_table_column, {
              label: "变更前公司/团队",
              prop: "beforeData"
            }),
            _createVNode(_component_el_table_column, {
              label: "变更后公司/团队",
              prop: "afterData"
            }),
            _createVNode(_component_el_table_column, {
              label: "变更日期",
              prop: "createdAt",
              formatter: _unref(formatTime)
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "是否同步维护基础薪酬",
              prop: "handle",
              formatter: (row) => row.handle === false ? '否' : '是'
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, { label: "操作" }, {
              default: _withCtx(({row}) => [
                _createVNode(_component_el_link, {
                  type: "primary",
                  onClick: ($event: any) => (changeHandle(row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_20
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, isChangeLoad.value]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "重新入职",
      width: 400,
      onClose: closeResign,
      modelValue: resignEmployeeVisiable.value,
      "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((resignEmployeeVisiable).value = $event))
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[51] || (_cache[51] = ($event: any) => (resignEmployeeVisiable.value=false))
        }, {
          default: _withCtx(() => [
            _hoisted_21
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          loading: resignLoading.value,
          onClick: resignHandle,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _hoisted_22
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "入职日期" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: resignInfo.value.date,
                  "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((resignInfo.value.date) = $event)),
                  type: "date",
                  placeholder: "请选择入职日期"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "人员状态" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: resignInfo.value.type,
                  "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((resignInfo.value.type) = $event)),
                  placeholder: "请选择人员状态",
                  style: {"width":"220px"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(humanType, (item) => {
                      return _createVNode(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"])
                    }), 64))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})